import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tab from '../tab';

const TabsMenu = ({ tabs }) => (
  <div className="site-main-nav-wrapper">
    <ul className="site-main-nav">
      {tabs.map(({ className, ...rest }) => (
        <Tab
          className={classnames('site-main-nav__item', className)}
          {...rest}
        />
      ))}
    </ul>
  </div>
);

TabsMenu.propTypes = {
  tabs: PropTypes.instanceOf(Array).isRequired,
};

export default TabsMenu;
